import { extendTheme } from '@chakra-ui/react';

import {
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_ALTERNATIVE,
  BUTTON_MAIN_COLOR,
  BUTTON_MAIN_GRADIENT,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: 'Playfair Display',
    subHeading: 'Playfair Display',
    subHeading_lv2: 'Playfair Display',
    body: 'Montserrat',


    // for generator purpose
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '52px',
    subHeading: '32px',
    subHeading_lv2: '18px',
    body: '16px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    subHeading_lv2: 400,
    body: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-subHeading_lv2': '',
        '--fontItalic-body': '',
      },
    },
  },
  colors: {
    bgPrimary: '#934b60',
    bgSecondary: '#fff8ed',
    mainColorText: '#000000',
    secondaryColorText: '#934b60',
    alternativeColorText: '#e0af34',
    btnMainColor: '#5f726d',
    btnMainGradient: '#a5b0a8',

    transparent: 'transparent',
  },
  breakpoints: {
    base: '0px',
    sm: '320px', // galaxy s9+
    '1sm': '375px', //iphone SE
    '2sm': '414px', //iphone XR
    '3sm': '500px', // > tablet
    md: '768px',
    lg: '960px',
    xl: '1200px',
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
  },
};

export default extendTheme(theme);
